import { getTheme } from './theming.utils';
import DefaultTheme from '../Branding/DefaultTheme.json';

export const getThemeFromConfig = () => {
	return getTheme(DefaultTheme);
};
